// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import {Dictionary} from '../../../shared/models/dictionary.model';
import {IBaseType} from '../../../shared/enums/ibase-type.enum';

export interface IIncidentMissingRequirementType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class IncidentMissingRequirementType implements IIncidentMissingRequirementType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Dealer Agent Signature IncidentStatusType
	**/
    get DealerAgentSignature(): IIncidentMissingRequirementType {
        return this.FromId(1);
    }
    /**
		Returns Dealer License IncidentStatusType
	**/
    get DealerLicense(): IIncidentMissingRequirementType {
        return this.FromId(2);
    }
    /**
		Returns One & The Same Affidavit IncidentStatusType
	**/
    get OneAndTheSameAffidavit(): IIncidentMissingRequirementType {
        return this.FromId(3);
    }
    /**
		Returns Power Of Attorney Form/Signatures IncidentStatusType
	**/
    get PowerOfAttorneyFormSignatures(): IIncidentMissingRequirementType {
        return this.FromId(4);
    }
    /**
		Returns Release Of Interest Form IncidentStatusType
	**/
    get ReleaseOfInterestForm(): IIncidentMissingRequirementType {
        return this.FromId(5);
    }
    /**
		Returns Statement Of Error IncidentStatusType
	**/
    get StatementOfError(): IIncidentMissingRequirementType {
        return this.FromId(6);
    }
    /**
		Returns Title Not Signed Properly IncidentStatusType
	**/
    get TitleNotSignedProperly(): IIncidentMissingRequirementType {
        return this.FromId(7);
    }
    /**
		Returns Other IncidentStatusType
	**/
    get Other(): IIncidentMissingRequirementType {
        return this.FromId(8);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'DealerAgentSignature', displayValue: 'Dealer Agent Signature', description: 'Dealer Agent Signature', sortOrder: 999999, active: true });
        this._dictionary.add('2', { id: 2, value: 'DealerLicense', displayValue: 'Dealer License', description: 'Dealer License', sortOrder: 999999, active: true });
        this._dictionary.add('3', { id: 3, value: 'OneAndTheSameAffidavit', displayValue: 'One & The Same Affidavit', description: 'One & The Same Affidavit', sortOrder: 999999, active: true });
        this._dictionary.add('4', { id: 4, value: 'PowerOfAttorneyFormSignatures', displayValue: 'Power Of Attorney Form/Signatures', description: 'Power Of Attorney Form/Signatures', sortOrder: 999999, active: true });
        this._dictionary.add('5', { id: 5, value: 'ReleaseOfInterestForm', displayValue: 'Release Of Interest Form', description: 'Release Of Interest Form', sortOrder: 999999, active: true });
        this._dictionary.add('6', { id: 6, value: 'StatementOfError', displayValue: 'Statement Of Error', description: 'Statement Of Error', sortOrder: 999999, active: true });
        this._dictionary.add('7', { id: 7, value: 'TitleNotSignedProperly', displayValue: 'Title Not Signed Properly', description: 'Title Not Signed Properly', sortOrder: 999999, active: true });
        this._dictionary.add('8', { id: 8, value: 'Other', displayValue: 'Other', description: 'Other', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IIncidentMissingRequirementType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IIncidentMissingRequirementType {
        var match = this._dictionary.getValues().filter(function(data) {
            return data.value == value;
        });

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IIncidentMissingRequirementType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IIncidentMissingRequirementType[] {
        return this.GetAll().filter(function(data) {
            return data.active;
        });
    }

    public Sort(primaryField, secondaryField, reverse): IIncidentMissingRequirementType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = function(path, reverse, primer, then) {
        var get = function(obj, path) {
                if (path) {
                    path = path.split('.');
                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }
                    return obj[path[len]];
                }
                return obj;
            },
            prime = function(obj) {
                return primer ? primer(get(obj, path)) : get(obj, path);
            };

        return function(a, b) {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
